export default "__VITE_ASSET__66cc3ae8__"